var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTodaysFit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.2885 30.4021L57.125 21.6242L41.15 9.19922C40.7242 10.4234 40.1019 11.4498 39.3629 12.3066C36.6732 15.4254 32.4373 16.2992 30.5 16.2992C26.6218 16.2992 23.6115 14.2726 21.7632 12.2086C20.7867 11.1182 20.1345 10.0173 19.85 9.19922L3.875 21.6242L10.7265 30.3927L16.3 26.0617V51.7992H44.7V26.0617L50.2885 30.4021ZM49.6661 25.4238L52.1415 22.2455L42.1682 14.4885C40.8178 16.0965 39.1917 17.2488 37.6117 18.0474C34.979 19.3783 32.2573 19.8492 30.5 19.8492C26.548 19.8492 23.3246 18.2642 21.0212 16.3908C20.2572 15.7695 19.564 15.0918 18.9559 14.392L8.86297 22.242L11.3439 25.4171L19.85 18.8073V48.2492H41.15V18.8096L49.6661 25.4238Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTodaysFit);
export default __webpack_public_path__ + "static/media/todaysFit.756f9642.svg";
export { ForwardRef as ReactComponent };